import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { fabric } from 'fabric';
import { IText } from 'fabric/fabric-impl';
import { fabricGif } from "./gifs/fabricGif";

@Component({
  selector: 'angular-editor-fabric-js',
  templateUrl: './angular-editor-fabric-js.component.html',
  styleUrls: ['./angular-editor-fabric-js.component.css'],
})
export class FabricjsEditorComponent implements AfterViewInit {
  @ViewChild('htmlCanvas') htmlCanvas: ElementRef;

  private canvas: fabric.Canvas;
  public props = {
    text: 'your text here',
    canvasFill: '#ffffff',
    canvasImage: '',
    id: null,
    opacity: null,
    fill: null,
    fontSize: null,
    lineHeight: null,
    charSpacing: null,
    fontWeight: null,
    fontStyle: null,
    textAlign: null,
    fontFamily: null,
    TextDecoration: '',
    rx: 0,
    ry: 0,
    inputName: '',
  };

  public textString: string;
  public url: string | ArrayBuffer = '';
  public originName: string | '';
  public size: any = {
    width: 500,
    height: 800
  };

  public json: any;
  private globalEditor = false;
  public textEditor = false;
  private imageEditor = false;
  public figureEditor = false;
  public selected: any;
  public gridShow = false;

  constructor() { }

  ngAfterViewInit(): void {

    // setup front side canvas
    this.canvas = new fabric.Canvas(this.htmlCanvas.nativeElement, {
      hoverCursor: 'pointer',
      selection: true,
      selectionBorderColor: 'blue'
    });

    this.canvas.on('object:moving', (e) => { });
    this.canvas.on('object:modified', (e) => { });
    this.canvas.on('selection:created', (e) => {
        const selectedObject = e.target;
        this.selected = selectedObject;
        selectedObject.hasRotatingPoint = true;
        selectedObject.transparentCorners = false;
        selectedObject.cornerColor = 'rgba(255, 87, 34, 0.7)';

        this.resetPanels();

        if (selectedObject.type !== 'activeSelection' && selectedObject) {

          this.getId();
          this.getOpacity();

          switch (selectedObject.type) {
            case 'rect':
            case 'circle':
            case 'triangle':
              this.figureEditor = true;
              this.getFill();
              break;
            case 'i-text':
              this.textEditor = true;
              this.getLineHeight();
              this.getCharSpacing();
              this.getBold();
              this.getFill();
              this.getTextDecoration();
              this.getTextAlign();
              this.getFontFamily();
              break;
            case 'text':
              this.textEditor = true;
              this.getLineHeight();
              this.getCharSpacing();
              this.getBold();
              this.getFill();
              this.getTextDecoration();
              this.getTextAlign();
              this.getFontFamily();
              break;
            case 'group':
              if (selectedObject['input']) {
                this.textEditor = true;
                this.getLineHeight();
                this.getCharSpacing();
                this.getBold();
                this.getFill();
                this.getTextDecoration();
                this.getTextAlign();
                this.getFontFamily();
              }
            case 'image':
              break;
          }
        } else if (selectedObject && selectedObject.type === 'activeSelection') {
          console.log('group selected');
        }
      });
    this.canvas.on('selection:cleared', (e) => {
        this.selected = null;
        this.resetPanels();
      });

    this.canvas.setWidth(this.size.width);
    this.canvas.setHeight(this.size.height);

    this.toggleGrid();

    // get references to the html canvas element & its context
    this.canvas.on('mouse:down', (e) => {
      const canvasElement: any = document.getElementById('canvas');
    });

  }


  /*------------------------Block elements------------------------*/

  // Block "Size"

  changeSize() {
    this.canvas.setWidth(this.size.width);
    this.canvas.setHeight(this.size.height);
  }

  update() {
    this.canvas.renderAll();
  }

  // Block "Add text"

  addIText() {
    if (this.textString) {
      const text = new fabric.IText(this.textString, {
        left: 10,
        top: 10,
        fontFamily: 'helvetica',
        angle: 0,
        fill: '#000000',
        scaleX: 0.5,
        scaleY: 0.5,
        fontWeight: '',
        hasRotatingPoint: true,
      });
      text['input'] = {
        type: 'text',
        max: 20,
        name: 'email',
      };

      this.extend(text, this.randomId());
      this.canvas.add(text);
      this.selectItemAfterAdded(text);
      this.textString = '';
    }
  }

  addText() {
    if (this.textString) {
      const text = new fabric.Text(this.textString, {
        left: 10,
        top: 10,
        fontFamily: 'helvetica',
        angle: 0,
        fill: '#000000',
        scaleX: 0.5,
        scaleY: 0.5,
        fontWeight: '',
        hasRotatingPoint: true
      });

      this.extend(text, this.randomId());
      this.canvas.add(text);
      this.selectItemAfterAdded(text);
      this.textString = '';
    }
  }

  // Block "Add images"

  getImgPolaroid(event: any) {
    const el = event.target;
    fabric.loadSVGFromURL(el.src, (objects, options) => {
      const image = fabric.util.groupSVGElements(objects, options);
      image.set({
        left: 10,
        top: 10,
        angle: 0,
        padding: 10,
        cornerSize: 10,
        hasRotatingPoint: true,
      });
      this.extend(image, this.randomId());
      this.canvas.add(image);
      this.selectItemAfterAdded(image);
    });
  }


  getVideoElement(url) {
    const videoE = document.createElement('video');
    videoE.muted = true;
    videoE.crossOrigin = 'anonymous';
    videoE.id = this.randomId().toString();
    videoE.autoplay = true;
    videoE.loop = true;
    const source = document.createElement('source');
    source.src = url;
    source.type = 'video/mp4';
    videoE.appendChild(source);

    return videoE;
  }

  isVideoMp4(url) {
    return(url.match(/\.(mp4)$/) != null);
  }

  // Block "Upload Image"
  addImageOnCanvas(url) {
    if (url) {
      if (this.isVideoMp4(url)) {
        const localCanvas = this.canvas;
        const urlMp4 = url;

        const videoE = this.getVideoElement(urlMp4);
        // debugger;
        videoE.onloadedmetadata = (ev) => {
          videoE.width = videoE.videoWidth;
          videoE.height = videoE.videoHeight;
          const fabVideo = new fabric.Image(videoE, {left: 0,   top: 0});

          fabVideo.set({
            left: 10,
            top: 10,
            angle: 0,
            padding: 0,
            cornerSize: 10,
            hasRotatingPoint: true,
            originX: 'center',
            originY: 'center',
            width: videoE.videoWidth,
            height: videoE.videoHeight
          });

          fabVideo['videoDataUrl'] = url;
          fabVideo['isVideo'] = true;
          fabVideo.scaleToWidth(200);
          this.canvas.add(fabVideo);
          this.selectItemAfterAdded(fabVideo);

          fabric.util.requestAnimFrame(function render() {
            localCanvas.renderAll();
            fabric.util.requestAnimFrame(render);
          });
        };

      } else {
        fabric.Image.fromURL(url, (image) => {
          image.set({
            left: 10,
            top: 10,
            angle: 0,
            padding: 10,
            cornerSize: 10,
            hasRotatingPoint: true
          });
          image.scaleToWidth(200);
          image.scaleToHeight(200);
          this.extend(image, this.randomId());
          this.canvas.add(image);
          this.selectItemAfterAdded(image);
        });
      }


    }
  }

  addVideoOnCanvas(obj) {
    var video1 = new fabric.Image(obj, {
      originX: 'center',
      originY: 'center',
      objectCaching: false,
    });
    debugger;
    this.canvas.add(video1);
    // video1.getElement().play();
  }

  readUrl(event) {
    if (event.target.files && event.target.files[0]) {
      this.originName = event.target.files[0].name;
      const reader = new FileReader();
      reader.onload = (readerEvent) => {
        this.url = readerEvent.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  removeWhite(url) {
    this.url = '';
  }

  // Block "Add figure"

  addFigure(figure) {
    let add: any;
    switch (figure) {
      case 'rectangle':
        add = new fabric.Rect({
          width: 200, height: 100, left: 10, top: 10, angle: 0,
          fill: '#3f51b5'
        });
        break;
      case 'square':
        add = new fabric.Rect({
          width: 100, height: 100, left: 10, top: 10, angle: 0,
          fill: '#4caf50'
        });
        break;
      case 'triangle':
        add = new fabric.Triangle({
          width: 100, height: 100, left: 10, top: 10, fill: '#2196f3'
        });
        break;
      case 'circle':
        add = new fabric.Circle({
          radius: 50, left: 10, top: 10, fill: '#ff5722'
        });
        break;
    }
    this.extend(add, this.randomId());
    this.canvas.add(add);
    this.selectItemAfterAdded(add);
  }

  /*Canvas*/

  cleanSelect() {
    this.canvas.discardActiveObject().renderAll();
  }

  selectItemAfterAdded(obj) {
    this.canvas.discardActiveObject().renderAll();
    this.canvas.setActiveObject(obj);
  }

  setCanvasFill() {
    if (!this.props.canvasImage) {
      this.canvas.backgroundColor = this.props.canvasFill;
      this.canvas.renderAll();
    }
  }

  extend(obj, id) {
    obj.toObject = ((toObject) => {
      return function() {
        return fabric.util.object.extend(toObject.call(this), {
          id
        });
      };
    })(obj.toObject);
  }

  setCanvasImage() {
    const self = this;
    if (this.props.canvasImage) {
      this.canvas.setBackgroundColor(new fabric.Pattern({ source: this.props.canvasImage, repeat: 'repeat' }), () => {
        self.props.canvasFill = '';
        self.canvas.renderAll();
      });
    }
  }

  randomId() {
    return Math.floor(Math.random() * 999999) + 1;
  }

  /*------------------------Global actions for element------------------------*/

  getActiveStyle(styleName, object) {
    object = object || this.canvas.getActiveObject();
    if (!object) { return ''; }

    if (object.getSelectionStyles && object.isEditing) {
      return (object.getSelectionStyles()[styleName] || '');
    } else {
      return (object[styleName] || '');
    }
  }

  setActiveStyle(styleName, value: string | number, object: fabric.IText) {
    if (this.canvas.getActiveObject().type === 'group') {
      object = this.getTextFromGroup(this.canvas.getActiveObject() as fabric.Group);
    }
    object = object || this.canvas.getActiveObject() as fabric.IText;

    if (!object) { return; }

    if (object.setSelectionStyles && object.isEditing) {
      const style = {};
      style[styleName] = value;

      if (typeof value === 'string') {
        if (value.includes('underline')) {
          object.setSelectionStyles({underline: true});
        } else {
          object.setSelectionStyles({underline: false});
        }

        if (value.includes('overline')) {
          object.setSelectionStyles({overline: true});
        } else {
          object.setSelectionStyles({overline: false});
        }

        if (value.includes('line-through')) {
          object.setSelectionStyles({linethrough: true});
        } else {
          object.setSelectionStyles({linethrough: false});
        }
      }

      object.setSelectionStyles(style);
      object.setCoords();

    } else {
      if (typeof value === 'string') {
        if (value.includes('underline')) {
        object.set('underline', true);
        } else {
          object.set('underline', false);
        }

        if (value.includes('overline')) {
          object.set('overline', true);
        } else {
          object.set('overline', false);
        }

        if (value.includes('line-through')) {
          object.set('linethrough', true);
        } else {
          object.set('linethrough', false);
        }
      }

      object.set(styleName, value);
    }

    object.setCoords();
    this.canvas.renderAll();
  }

  getTextFromGroup(group: fabric.Group) {
    let text: fabric.IText;
    group.forEachObject((obj) => {
      if (obj.type === 'i-text' || obj.type === 'text') {
        text = obj as fabric.IText;
      }
    });
    return text;
  }

  getActiveProp(name) {
    const object = this.canvas.getActiveObject();
    if (!object) { return ''; }

    return object[name] || '';
  }

  setActiveProp(name, value) {
    const object = this.canvas.getActiveObject();
    if (!object) { return; }
    object.set(name, value).setCoords();
    this.canvas.renderAll();
  }

  clone() {
    const activeObject = this.canvas.getActiveObject();
    const activeGroup = this.canvas.getActiveObjects();

    if (activeObject) {
      let clone;
      switch (activeObject.type) {
        case 'rect':
          clone = new fabric.Rect(activeObject.toObject());
          break;
        case 'circle':
          clone = new fabric.Circle(activeObject.toObject());
          break;
        case 'triangle':
          clone = new fabric.Triangle(activeObject.toObject());
          break;
        case 'i-text':
          clone = new fabric.IText('', activeObject.toObject());
          break;
        case 'image':
          clone = fabric.util.object.clone(activeObject);
          break;
      }
      if (clone) {
        clone.set({ left: 10, top: 10 });
        this.canvas.add(clone);
        this.selectItemAfterAdded(clone);
      }
    }
  }

  getId() {
    this.props.id = this.canvas.getActiveObject().toObject().id;
  }

  setId() {
    const val = this.props.id;
    const complete = this.canvas.getActiveObject().toObject();
    console.log(complete);
    this.canvas.getActiveObject().toObject = () => {
      complete.id = val;
      return complete;
    };
  }

  setInputName() {
    this.canvas.getActiveObject()['input'].name = this.props.inputName;
  }

  getOpacity() {
    this.props.opacity = this.getActiveStyle('opacity', null) * 100;
  }

  setOpacity() {
    this.setActiveStyle('opacity', parseInt(this.props.opacity, 10) / 100, null);
  }

  getFill() {
    this.props.fill = this.getActiveStyle('fill', null);
  }

  setFill() {
    this.setActiveStyle('fill', this.props.fill, null);
  }

  setText() {
    this.setActiveStyle('text', this.props.text, null);
  }

  setBorderRadius() {
    this.setActiveProp('rx', this.props.rx);
    this.setActiveProp('ry', this.props.ry);
  }

  getLineHeight() {
    this.props.lineHeight = this.getActiveStyle('lineHeight', null);
  }

  setLineHeight() {
    this.setActiveStyle('lineHeight', parseFloat(this.props.lineHeight), null);
  }

  getCharSpacing() {
    this.props.charSpacing = this.getActiveStyle('charSpacing', null);
  }

  setCharSpacing() {
    this.setActiveStyle('charSpacing', this.props.charSpacing, null);
  }

  getFontSize() {
    this.props.fontSize = this.getActiveStyle('fontSize', null);
  }

  setFontSize() {
    this.setActiveStyle('fontSize', parseInt(this.props.fontSize, 10), null);
  }

  getBold() {
    this.props.fontWeight = this.getActiveStyle('fontWeight', null);
  }

  setBold() {
    this.props.fontWeight = !this.props.fontWeight;
    this.setActiveStyle('fontWeight', this.props.fontWeight ? 'bold' : '', null);
  }

  setFontStyle() {
    this.props.fontStyle = !this.props.fontStyle;
    if (this.props.fontStyle) {
      this.setActiveStyle('fontStyle', 'italic', null);
    } else {
      this.setActiveStyle('fontStyle', 'normal', null);
    }
  }

  getTextDecoration() {
    this.props.TextDecoration = this.getActiveStyle('textDecoration', null);
  }

  setTextDecoration(value) {
    let iclass = this.props.TextDecoration;
    if (iclass.includes(value)) {
      iclass = iclass.replace(RegExp(value, 'g'), '');
    } else {
      iclass += ` ${value}`;
    }
    this.props.TextDecoration = iclass;
    this.setActiveStyle('textDecoration', this.props.TextDecoration, null);
  }

  hasTextDecoration(value) {
    return this.props.TextDecoration.includes(value);
  }

  getTextAlign() {
    this.props.textAlign = this.getActiveProp('textAlign');
  }

  setTextAlign(value) {
    this.props.textAlign = value;
    this.setActiveProp('textAlign', this.props.textAlign);
  }

  getFontFamily() {
    this.props.fontFamily = this.getActiveProp('fontFamily');
  }

  setFontFamily() {
    this.setActiveProp('fontFamily', this.props.fontFamily);
  }

  setObjectAlignment(value: 'left' | 'center' | 'right') {
    const group = this.selected;

    group.forEachObject((obj: fabric.Object) => {
      const itemW = obj.getBoundingRect().width;
      const itemH = obj.getBoundingRect().height;

      switch (value) {
        case 'left':
          obj.set({
            left: -(group.width / 2),
            originX: 'left'
          });
          break;

        case 'center':
          obj.set({
            left: (0 - itemW/2),
            originX: 'left'
          })
          break;

        case 'right':
          obj.set({
            left: (group.width/2 - itemW/2),
            originX: 'center'
          });
          break;
      }
      obj.setCoords();
    });

    this.canvas.renderAll()
  }


  /*System*/

  removeSelected() {
    const activeObject = this.canvas.getActiveObject();
    const activeGroup = this.canvas.getActiveObjects();

    if (activeObject) {
      this.canvas.remove(activeObject);
      // this.textString = '';
    } else if (activeGroup) {
      this.canvas.discardActiveObject();
      const self = this;
      activeGroup.forEach((object) => {
        self.canvas.remove(object);
      });
    }
  }

  bringToFront() {
    const activeObject = this.canvas.getActiveObject();
    const activeGroup = this.canvas.getActiveObjects();

    if (activeObject) {
      activeObject.bringToFront();
      activeObject.opacity = 1;
    } else if (activeGroup) {
      this.canvas.discardActiveObject();
      activeGroup.forEach((object) => {
        object.bringToFront();
      });
    }
  }

  sendToBack() {
    const activeObject = this.canvas.getActiveObject();
    const activeGroup = this.canvas.getActiveObjects();

    if (activeObject) {
      this.canvas.sendToBack(activeObject);
      activeObject.sendToBack();
      activeObject.opacity = 1;
    } else if (activeGroup) {
      this.canvas.discardActiveObject();
      activeGroup.forEach((object) => {
        object.sendToBack();
      });
    }
  }

  confirmClear() {
    if (confirm('Are you sure?')) {
      this.canvas.clear();
    }
  }

  rasterize() {
    const image = new Image();
    image.src = this.canvas.toDataURL({format: 'png'});
    const w = window.open('');
    w.document.write(image.outerHTML);
  }

  getSVG() {
    return this.canvas.toSVG();
  }

  rasterizeSVG() {
    const w = window.open('');
    w.document.write(this.canvas.toSVG());
    return 'data:image/svg+xml;utf8,' + encodeURIComponent(this.canvas.toSVG());
  }

  saveCanvasToJSON() {
    const json = JSON.stringify(this.canvas);
    localStorage.setItem('Kanvas', json);
    console.log('json');
    console.log(json);

  }

  loadCanvasfromJSONFile(json : Object) {
    this.canvas.loadFromJSON(json, () => {
      this.canvas.renderAll();
    }); 
  }

  loadCanvasFromJSON() {
    const CANVAS = localStorage.getItem('Kanvas');
    console.log('CANVAS');
    console.log(CANVAS);

    // and load everything from the same json
    this.canvas.loadFromJSON(CANVAS, () => {
      console.log('CANVAS untar');
      console.log(CANVAS);

      // making sure to render canvas at the end
      this.canvas.renderAll();

      // and checking if object's "name" is preserved
      console.log('this.canvas.item(0).name');
      console.log(this.canvas);
    });

  }

  rasterizeJSON() {
    this.gridShow = false;
    this.removeGridLines();
    this.json = JSON.stringify(this.canvas.toJSON(['gifDataUrl', 'isGif', 'isVideo', 'videoDataUrl', 'input']), null, 2);
  }

  resetPanels() {
    this.textEditor = false;
    this.imageEditor = false;
    this.figureEditor = false;
  }

  addButton() {
    var rectangle = new fabric.Rect({
      width: 200,
      height: 50,
      fill: "#3f51b5",
      originX: 'center',
      originY: 'center'
    });

    var text = new fabric.IText('Click Here', {
      fontSize: 24,
      fill: "#ffffff",
      width: 200,
      height: 100,
      originX: 'center',
      originY: 'center',
    });

    var group = new fabric.Group([ rectangle, text ], {
      left: 10,
      top: 10,
    });
    group['input'] = {
      type: 'button',
      name: 'button',
    }

    this.canvas.add(group);
  }

  addInput() {
    var rectangle = new fabric.Rect({
      width: 200,
      height: 50,
      fill: "#c2c2c2",
      originX: 'center',
      originY: 'center'
    });

    var text = new fabric.IText('Write Here', {
      fontSize: 24,
      fill: "#ffffff",
      width: 200,
      height: 100,
      originX: 'center',
      originY: 'center',
    });

    var group = new fabric.Group([ rectangle, text ], {
      left: 10,
      top: 10,
    });
    group['input'] = {
      type: 'text',
      name: 'input',
    }

    this.canvas.add(group);
  }

  addGiftOnCanvas(url) {
    fabricGif(
      url,
      200,
      200
    ).then(gif2 => {
      gif2.set({ top: 50, left: 300 });
      const localCanvas = this.canvas;
      localCanvas.add(gif2);

      fabric.util.requestAnimFrame(function render() {
        localCanvas.renderAll();
        fabric.util.requestAnimFrame(render);
      });

    });

  }

  addGridLines() {
    const grid = 50;

    const canvasHeight = this.size.height;
    const canvasWidth = this.size.width;

    for (let i = 1; i < (canvasWidth / grid); i++) {
      const newLine = new fabric.Line([ i * grid, 0, i * grid, canvasHeight], { type: 'line', stroke: '#888', selectable: false, strokeDashArray: [5, 5] });
      newLine['isGrid'] = true;
      this.canvas.add(newLine);
    }

    for (let i = 1; i < (canvasHeight / grid); i++) {
      const newLine = new fabric.Line([ 0, i * grid, canvasWidth, i * grid], { type: 'line', stroke: '#888', selectable: false, strokeDashArray: [5, 5] });
      newLine['isGrid'] = true;
      this.canvas.add(newLine);
    }
  }

  removeGridLines() {
    const allObjects = this.canvas.getObjects('line');
    allObjects.forEach((object) => {
      if (object['isGrid'] === true) {
        this.canvas.remove(object);
      }
    });
  }

  toggleGrid() {
    this.gridShow = !this.gridShow;

    if (this.gridShow) {
      this.addGridLines();
    } else {
      this.removeGridLines();
    }
  }

}
